export const GESTIONES_TABS = [
  'revisar_hoy',
  'esperando_cliente',
  'fuera_de_plazo',
  'activas',
  'cerradas',
] as const;
export type GestionesTab = (typeof GESTIONES_TABS)[number];

export const TAB_LABELS: Record<GestionesTab, string> = {
  revisar_hoy: 'A revisar hoy',
  esperando_cliente: 'Esperando cliente',
  fuera_de_plazo: 'Fuera de plazo',
  activas: 'Activas',
  cerradas: 'Cerradas',
};

export const CARD_TABS: Set<GestionesTab> = new Set([
  'revisar_hoy',
  'esperando_cliente',
  'fuera_de_plazo',
]);

export const ESTADO_LABELS: Record<string, { label: string; bg: string; fg: string }> = {
  activa: {
    label: 'Activa',
    bg: 'var(--color-success-bg)',
    fg: 'var(--color-success-fg)',
  },
  esperando_cliente: {
    label: 'Esperando cliente',
    bg: 'var(--color-warning-bg)',
    fg: 'var(--color-warning-fg)',
  },
  esperando_organismo: {
    label: 'Esperando organismo',
    bg: 'var(--color-info-bg)',
    fg: 'var(--color-info-fg)',
  },
  pausada: {
    label: 'Pausada',
    bg: 'var(--color-bg-overlay)',
    fg: 'var(--color-fg-muted)',
  },
  cerrada: {
    label: 'Cerrada',
    bg: 'var(--color-bg-overlay)',
    fg: 'var(--color-fg-subtle)',
  },
};

export const TIPO_LABELS: Record<string, string> = {
  inicio_actividades: 'Inicio Actividades',
  termino_giro: 'Término de Giro',
  consulta_dt: 'Consulta DT',
  otro: 'Otro',
};

export const BLOQUEO_OPTIONS = [
  { value: 'activa', label: 'Activa' },
  { value: 'esperando_cliente', label: 'Esperando cliente' },
  { value: 'esperando_organismo', label: 'Esperando organismo' },
  { value: 'pausada', label: 'Pausada' },
] as const;
